import { PlayerEvent, type PlayerInterface } from '@foundation-player/loader';
import { readonly, writable, type Readable, type Writable } from 'svelte/store';
import type { PlayerStoreModule } from './player-store-types';

export class LiveMediumPlayerStore implements PlayerStoreModule<'liveMedium'> {
  readonly #liveMedium: Writable<boolean> = writable(false);
  readonly liveMedium: Readable<boolean> = readonly(this.#liveMedium);

  initializeStateFromPlayer(player: PlayerInterface) {
    player.addEventListener(PlayerEvent.Ready, () => this.#liveMedium.set(player.isLive()));
    this.#liveMedium.set(player.isLive());
  }
}
